import styled from 'react-emotion';
import React from 'react';
import Button from '../components/Button';

import Paperplane from '../icons/fa-solid/Paperplane.jsx';
import Browser from '../util/Browser';
import { hide } from '../util/hide';

const StyleInput = styled.input`
  color: ${props => props.theme.set.light.p};
  font-size: 22px;
  font-weight: bold;

  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 1.5rem;

  border-radius: 0.35rem;
  border: 2px solid lightgray;
  width: 100%;
  ::placeholder {
    color: ${props => props.theme.set.light.placeholder};
  }
  background-color: ${props => props.theme.set.light.bgText};
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.75);
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  background-image: linear-gradient(
    5deg,
    rgba(0, 10, 29, 0.19) 0%,
    rgba(0, 10, 29, 0) 35%,
    hsla(240, 60%, 97%, 0.25) 100%
  );
  &:hover {
    shadow: 0px 6px 18px 0px rgba(0, 0, 0, 0.7);
    background-color: ${props => props.theme.set.light.trimOn};
  }
  &:focus {
    shadow: 0px 6px 22px 0px rgba(0, 0, 0, 0.5);
    background-color: ${props => props.theme.set.light.pure};
  }
`;

const EmailTab2 = styled.div`
  position: relative;
  display: inline-block;
  top: -47.5rem;
  padding-bottom: 3rem;
  margin-left: 5%;
  margin-right: 95%;
  height: 0.25rem;
  text-align: center;
  z-index: 9;
  color: ${props => props.theme.set.light.p};
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  border-radius: 0.35rem;
  border: 2px solid lightgray;
  background-color: ${props => props.theme.set.light.trimOn};
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.25);
  /*
  background-image: linear-gradient(
    5deg,
    hsla(240, 60%, 97%, 0.25) 0%,
    rgba(0, 10, 29, 0) 75%,
    rgba(0, 10, 29, 0.29) 100%
  );
  */
  padding: 1rem;
  @media (min-width: 900px) {
    top: -49.12rem;
  }
  @media (max-width: 900px) {
    top: -47.55rem;
  }
  @media (max-width: 599px) {
    top: -48.75rem;
  }
  @media (max-width: 400px) {
    top: -50.4rem;
  }
`;

const TextAreaTab = styled.div`
  position: relative;
  display: inline-block;
  top: -38.25rem;
  padding-bottom: 3rem;
  margin-left: 5%;
  margin-right: 95%;
  height: 0.25rem;
  max-height: 0.25rem;
  text-align: center;
  z-index: 9;
  color: ${props => props.theme.set.light.p};
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  border-radius: 0.35rem;
  border: 2px solid lightgray;
  background-color: ${props => props.theme.set.light.trimOn};
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.25);
  /*
  background-image: linear-gradient(
    5deg,
    hsla(240, 60%, 97%, 0.25) 0%,
    rgba(0, 10, 29, 0) 75%,
    rgba(0, 10, 29, 0.29) 100%
  );
  */
  padding: 1rem;
  @media (max-width: 400px) {
    top: -38.25rem;
  }
`;

const TabText = styled.h1`
  font-size: 1.75rem;
  position: relative;
  display: inline-block;
  top: -0.8rem;
  padding-left: 0rem;
  padding-bottom: 0rem;
  left: -0.1rem;
  margin-left: 0rem;
  z-index: 9;
  text-shadow: ${props => props.theme.set.light.shadow._3dThin};
  @media (max-width: 450px) {
    font-size: 1.6rem;
  }
`;

const StyledTextArea = styled.textarea`
  color: ${props => props.theme.set.light.p};
  resize: none;
  font-size: 22px;
  font-weight: bold;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 1.65rem;
  border-radius: 0.35rem;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.75);
  border: 2px solid lightgray;
  width: 100%;
  min-height: 30rem;
  ::placeholder {
    color: ${props => props.theme.set.light.placeholder};
  }
  background-color: ${props => props.theme.set.light.bgText};
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  background-image: linear-gradient(
    5deg,
    rgba(0, 10, 29, 0.29) 0%,
    rgba(0, 10, 29, 0) 75%,
    hsla(240, 60%, 97%, 0.25) 100%
  );
  &:hover {
    box-shadow: 0px 6px 18px 0px rgba(0, 0, 0, 0.7);
    background-color: ${props => props.theme.set.light.trimOn};
  }
  &:focus,
  &:active {
    ${TextAreaTab} {
      top: -39rem;
    }

    box-shadow: 0px 6px 22px 0px rgba(0, 0, 0, 0.5);
    background-color: ${props => props.theme.set.light.pure};
  }
`;

const IconDiv = styled.div`
  font-weight: 900;
  font-family: '';
  font-size: 22px;
  z-index: 12;
  text-indent: -5px;
  border-radius: 0.35rem;
  color: black;
  top: -43px;
  left: -5px;
  position: relative;
  width: 60px;
  opacity: 0;
`;

const EmailnNameLabel = styled.label`
  width: 100%;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const SpaceLabel = styled.label`
  width: 2%;
  @media (max-width: 900px) {
    width: 0px;
  }
`;

const EmailDiv = styled.div`
  positon: absolute;
  display: inline-block;
  transform: translateY(-0.25rem);
  padding-right: 0rem;
  svg {
    g {
      stroke-width: 3;
    }
  }
`;

const agent = Browser();
/*
let SubjectY,
  NameY,
  EmailY = 0;
*/
// const hide = () => {
//   if (typeof document.getElementById !== 'undefined') {
//     if (agent === 'safari') {
//     if (typeof document.getElementById('EmailTab') !== 'undefined') {
//       document.getElementById('EmailTab').style.display = 'none';
//     }
//     document.getElementById('NameTab').style.display = 'none';
//     document.getElementById('SubjectTab').style.display = 'none';
//     }
//   }
// };

const display = 'inline-block';

const EmailFormDetails = () => {
  if (agent === 'safari') {
    // display = 'none';
  }
  return (
    <React.Fragment>
      <EmailnNameLabel>
        <StyleInput id="emailIn" type="email" name="email" maxlength="512" placeholder="You@Email.com" required />
        <IconDiv type="text" name="emailIcon">
          A
        </IconDiv>
      </EmailnNameLabel>
      <SpaceLabel id="SpaceLabel" />
      <StyledTextArea
        id="message"
        name="message"
        type="text"
        maxlength="9999"
        placeholder="Hi, I'm looking for..."
        required
      />
      <Button type="main">
        <EmailDiv>
          <Paperplane />
        </EmailDiv>
        {`${'\u00A0'}:${'\u00A0'}:${'\u00A0'}EMAIL${'\u00A0'}:${'\u00A0'}:`}
      </Button>
      <TextAreaTab style={{ display: `${display}` }}>
        <TabText>Message{'\u00A0'}:</TabText>
      </TextAreaTab>
      <span className={hide}>
        <EmailTab2 id="EmailTab2" style={{ display: `${display}` }}>
          <TabText>Email{'\u00A0'}:</TabText>
        </EmailTab2>
      </span>
      <br />
      <br />
    </React.Fragment>
  );
};

export default EmailFormDetails;
// <span className={hide}>



// WEBPACK FOOTER //
// ./src/components/EmailFormDetails.jsx